import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CopyLink from './components/CopyLink';
import CopyApiLink from './components/CopyApiLink';
import { Wrapper, InputTitle, IconVulnerability } from './styled';
import { selectVulnDetail } from 'store/ManageGeneral/selectors';
import { showBulkUpdateModal } from 'store/ManageGeneral/actions';
import { useIntl } from 'react-intl';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_VULNS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const Title = () => {
  const dispatch = useDispatch();
  const vulnDetail = useSelector(selectVulnDetail);
  const canUpdate = useSelector((state) => selectAllowedByRole(state, FEATURE_VULNS, PERMISSION_TYPES.UPDATE));
  const [vulnName, setVulnName] = useState(vulnDetail.name);
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'manage.cm.edit.name' });

  useEffect(() => {
    setVulnName(vulnDetail.name);
  }, [vulnDetail]);

  const handleChange = (e) => {
    const name = e.target.value;
    dispatch(showBulkUpdateModal('name', name));
  };

  return (
    <Wrapper>
      <IconVulnerability />
      <InputTitle title={ title } value={ vulnName } onClick={ handleChange } disabled={ !canUpdate } />
      <CopyLink />
      <CopyApiLink />
    </Wrapper>
  );
};

export default Title;
